import { render, staticRenderFns } from "./DetailRequestStockPei.vue?vue&type=template&id=43e99e46&"
import script from "./DetailRequestStockPei.vue?vue&type=script&lang=js&"
export * from "./DetailRequestStockPei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports